/* Zafran vs Patchouli — the ritual
   Quiz mode: full-screen overlay, scores, redirects to the results page.
   Result mode: renders the reveal from ?r, quick-add, share card, waitlist.
   Tracks via Klaviyo onsite. No em dashes. British English. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function emailValid(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }
  function param(name) {
    try { return new URLSearchParams(window.location.search).get(name) || ''; } catch (e) { return ''; }
  }
  function slugVal() { var h = param('h'); return h ? h.trim().slice(0, 60) : ''; }
  function parseConfig(el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  function track(name, props, slug) {
    try {
      var payload = Object.assign({}, props || {});
      if (slug) payload.influencer_slug = slug;
      var kl = window.klaviyo || window._learnq;
      if (kl && typeof kl.push === 'function') kl.push(['track', name, payload]);
    } catch (e) {}
  }
  function identify(email, props) {
    try {
      var kl = window.klaviyo || window._learnq;
      if (kl && typeof kl.push === 'function') kl.push(['identify', Object.assign({ '$email': email }, props || {})]);
    } catch (e) {}
  }
  function shuffle(arr) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; }
    return a;
  }
  function localized(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/+$/, '') + '/' + String(path).replace(/^\//, '');
  }
  function personalize(p, name) {
    if (name) return p.replace(/\{name\}/g, name);
    p = p.replace(/\{name\}, /g, '').replace(/\{name\}/g, '');
    return p.charAt(0).toUpperCase() + p.slice(1);
  }
  function boaHsl(hex) {
    hex = String(hex).replace('#', '');
    if (hex.length === 3) hex = hex.replace(/(.)/g, '$1$1');
    var r = (parseInt(hex.slice(0, 2), 16) || 0) / 255, g = (parseInt(hex.slice(2, 4), 16) || 0) / 255, b = (parseInt(hex.slice(4, 6), 16) || 0) / 255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b), d = max - min, h = 0, s = 0, l = (max + min) / 2;
    if (d) {
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      if (max === r) h = (g - b) / d + (g < b ? 6 : 0);
      else if (max === g) h = (b - r) / d + 2;
      else h = (r - g) / d + 4;
      h *= 60;
    }
    return [h, s * 100, l * 100];
  }
  // Gradient = a dark->light tonal ramp of the leaning bottle's OWN colour,
  // plus a small accent of the OTHER bottle's colour for contrast.
  function boaGradient(ownHex, otherHex) {
    var o = boaHsl(ownHex), x = boaHsl(otherHex), L = o[2];
    function t(l) { return 'hsl(' + Math.round(o[0]) + ',' + Math.round(o[1]) + '%,' + Math.round(Math.max(12, Math.min(90, l))) + '%)'; }
    var darkest = t(L * 0.40), dark = t(L * 0.68), mid = t(L), light = t(L + (100 - L) * 0.42), lightest = t(L + (100 - L) * 0.70);
    var accent = 'hsl(' + Math.round(x[0]) + ',' + Math.round(x[1]) + '%,' + Math.round(Math.max(38, Math.min(60, x[2]))) + '%)';
    return 'linear-gradient(-45deg, ' + accent + ' 0%, ' + darkest + ' 16%, ' + dark + ' 36%, ' + mid + ' 56%, ' + light + ' 78%, ' + lightest + ' 100%)';
  }

  /* ===================== QUIZ (overlay) ===================== */
  function initQuiz(root) {
    var cfgEl = root.querySelector('[data-boa-config]');
    var cfg = cfgEl && parseConfig(cfgEl);
    if (!cfg || !cfg.questions || !cfg.questions.length) return;

    var overlay = root.querySelector('[data-boa-overlay]');
    var nameScreen = root.querySelector('[data-boa-name-screen]');
    var nameInput = root.querySelector('[data-boa-name-input]');
    var nameGo = root.querySelector('[data-boa-name-go]');
    var nameSkip = root.querySelector('[data-boa-name-skip]');
    var stage = root.querySelector('[data-boa-stage]');
    var needle = root.querySelector('[data-boa-needle]');
    var progress = root.querySelector('[data-boa-progress]');
    var questionEl = root.querySelector('[data-boa-question]');
    var optionsEl = root.querySelector('[data-boa-options]');
    var closeBtn = root.querySelector('[data-boa-close]');
    var slug = slugVal();
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var resultsUrl = (cfg.resultsUrl || '/pages/zafran-vs-patchouli-result');
    var tint = root.querySelector('[data-boa-tint]');
    var tintCfg = cfg.tint || {};
    var zafranTint = tintCfg.zafran || '#E04E39';
    var patchouliTint = tintCfg.patchouli || '#2E6E9E';
    var TINT_CAP = 3, TINT_MAX = 0.82, TINT_BASE = 0.24;

    var state = { i: 0, zafran: 0, patchouli: 0, leaderAtQ5: null, name: '' };

    function show(el, yes) { if (el) el.hidden = !yes; }
    function setNeedle() {
      if (!needle) return;
      needle.style.transform = 'rotate(' + Math.max(-70, Math.min(70, (state.patchouli - state.zafran) * 15)) + 'deg)';
    }
    function setInk(dark) {
      if (!overlay) return;
      overlay.style.setProperty('--boa-overlay-ink', dark ? 'var(--color-white)' : 'var(--boa-ink)');
    }
    function setTint() {
      if (!tint) return;
      var lead = state.zafran - state.patchouli;
      if (lead === 0) { tint.style.opacity = '0'; setInk(0); return; }
      var mag = Math.min(Math.abs(lead) / TINT_CAP, 1);
      var own = lead > 0 ? zafranTint : patchouliTint, other = lead > 0 ? patchouliTint : zafranTint;
      tint.style.backgroundImage = boaGradient(own, other);
      var op = TINT_BASE + mag * (TINT_MAX - TINT_BASE);
      tint.style.opacity = op.toFixed(3);
      setInk(op >= 0.52);
    }
    function renderQuestion() {
      var q = cfg.questions[state.i];
      if (progress) progress.textContent = 'Question ' + (state.i + 1) + ' of ' + cfg.questions.length;
      if (questionEl) questionEl.textContent = personalize(q.prompt, state.name);
      optionsEl.innerHTML = '';
      shuffle(q.options).forEach(function (opt) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'boa-option'; b.textContent = opt.text;
        b.addEventListener('click', function () { choose(opt.side, b); });
        optionsEl.appendChild(b);
      });
    }
    function choose(side, btn) {
      btn.classList.add('is-chosen');
      state[side] += 1; setNeedle(); setTint();
      track('Question Answered', { question_index: state.i + 1, side: side }, slug);
      if (state.i === 4) state.leaderAtQ5 = state.zafran === state.patchouli ? side : (state.zafran > state.patchouli ? 'zafran' : 'patchouli');
      var next = function () { state.i += 1; if (state.i < cfg.questions.length) renderQuestion(); else finish(); };
      if (reduce) { next(); return; }
      if (questionEl) questionEl.classList.add('is-out');
      window.setTimeout(function () { if (questionEl) questionEl.classList.remove('is-out'); next(); }, 320);
    }
    function result() {
      if (state.zafran > state.patchouli) return 'zafran';
      if (state.patchouli > state.zafran) return 'patchouli';
      return state.leaderAtQ5 || 'zafran';
    }
    function finish() {
      var r = result();
      track('Quiz Completed', { result: r === 'zafran' ? 'Zafran' : 'Patchouli' }, slug);
      var url = localized(resultsUrl) + '?r=' + r + (state.name ? '&n=' + encodeURIComponent(state.name) : '') + (slug ? '&h=' + encodeURIComponent(slug) : '');
      window.location.href = url;
    }
    function startQuestions(name) {
      state.i = 0; state.zafran = 0; state.patchouli = 0; state.leaderAtQ5 = null;
      state.name = (name || '').trim().slice(0, 40);
      show(nameScreen, false); show(stage, true); show(progress, true);
      setNeedle(); setTint(); renderQuestion();
    }
    function open() {
      if (!overlay) return;
      state = { i: 0, zafran: 0, patchouli: 0, leaderAtQ5: null, name: '' };
      if (nameInput) nameInput.value = '';
      if (tint) tint.style.opacity = '0';
      setInk(0);
      show(nameScreen, true); show(stage, false); show(progress, false);
      overlay.classList.add('is-open');
      document.documentElement.classList.add('boa-locked');
      track('Quiz Started', {}, slug);
      if (nameInput) { try { nameInput.focus(); } catch (e) {} }
    }
    function close() {
      if (!overlay) return;
      overlay.classList.remove('is-open');
      document.documentElement.classList.remove('boa-locked');
    }

    Array.prototype.forEach.call(document.querySelectorAll('[data-boa-open], a[href="#ritual"]'), function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
    if (nameGo) nameGo.addEventListener('click', function () { startQuestions(nameInput ? nameInput.value : ''); });
    if (nameSkip) nameSkip.addEventListener('click', function () { startQuestions(''); });
    if (nameInput) nameInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); startQuestions(nameInput.value); } });
    if (closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay && overlay.classList.contains('is-open')) close(); });
  }

  /* ===================== RESULT (page) ===================== */
  function initResult(root) {
    var cfgEl = root.querySelector('[data-boa-config]');
    var cfg = cfgEl && parseConfig(cfgEl);
    if (!cfg || !cfg.results) return;

    var slug = slugVal();
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var r = param('r');
    if (r === 'bijou') r = 'zafran'; else if (r === 'atlas') r = 'patchouli';
    var name = (param('n') || '').trim().slice(0, 40);
    if (r !== 'zafran' && r !== 'patchouli') {
      var empty = root.querySelector('[data-boa-empty]');
      if (empty) empty.style.display = 'block';
      var content = root.querySelector('[data-boa-content]');
      if (content) content.style.display = 'none';
      return;
    }
    root.setAttribute('data-result', r);
    var data = cfg.results[r];
    var partner = r === 'zafran' ? 'patchouli' : 'zafran';
    var pdata = cfg.results[partner];

    function set(sel, text) { var el = root.querySelector(sel); if (el) el.textContent = text; }
    set('[data-boa-result-title]', data.title);
    set('[data-boa-triplet]', data.triplet.join(' · '));
    set('[data-boa-notes]', data.notes);
    set('[data-boa-closer]', data.closer);
    set('[data-boa-partner-name]', pdata.name);
    set('[data-boa-partner-notes]', pdata.notes);
    set('[data-boa-shared]', cfg.shared);
    set('[data-boa-greeting]', name ? name + ',' : '');

    var atmo = root.querySelector('[data-boa-atmosphere]');
    if (atmo) {
      atmo.innerHTML = '';
      data.atmosphere.forEach(function (word, idx) {
        var s = document.createElement('span'); s.textContent = word; atmo.appendChild(s);
        if (reduce) s.classList.add('is-in');
        else window.setTimeout(function () { s.classList.add('is-in'); }, 200 + idx * 160);
      });
    }

    var videos = root.querySelectorAll('[data-boa-reveal-video]');
    function playVideo(side) {
      Array.prototype.forEach.call(videos, function (v) {
        if (v.getAttribute('data-boa-reveal-video') === side) {
          v.classList.add('is-active'); var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else { v.classList.remove('is-active'); try { v.pause(); } catch (e) {} }
      });
    }
    playVideo(r);

    Array.prototype.forEach.call(root.querySelectorAll('[data-boa-buy]'), function (c) {
      c.classList.toggle('is-active', c.getAttribute('data-boa-buy') === r);
    });

    /* Market-aware prices: re-fetch in the buyer's real market (bypasses the cached page currency) */
    (function () {
      var base = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/+$/, '');
      var cc = null;
      function fmt(cents) { try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cc }).format(cents / 100); } catch (e) { return null; } }
      function applyTo(card) {
        var handle = card.getAttribute('data-handle');
        var sel = card.querySelector('.boa-buy__select');
        if (!handle || !sel) return;
        fetch(base + '/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (res) { return res.ok ? res.json() : null; })
          .then(function (p) {
            if (!p || !p.variants) return;
            var map = {}; p.variants.forEach(function (v) { map[String(v.id)] = v; });
            Array.prototype.forEach.call(sel.options, function (opt) {
              var v = map[String(opt.value)]; if (!v) return;
              var price = cc ? fmt(v.price) : null;
              opt.textContent = v.title + (price ? ' · ' + price : '');
            });
          }).catch(function () {});
      }
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (c) {
          cc = (c && c.currency) || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || null;
          Array.prototype.forEach.call(root.querySelectorAll('[data-boa-buy]'), applyTo);
        }).catch(function () {});
    })();

    var flip = root.querySelector('[data-boa-flip]');
    if (flip) flip.addEventListener('click', function () {
      if (root.classList.contains('is-flipped')) return;
      root.classList.add('is-flipped');
      playVideo(partner);
      track('Card Flipped', { result: data.label }, slug);
    });

    /* quick add */
    Array.prototype.forEach.call(root.querySelectorAll('[data-boa-buy-form]'), function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var idField = form.querySelector('[name="id"]');
        if (!idField || !idField.value) return;
        var btn = form.querySelector('.boa-buy__add');
        if (btn) btn.setAttribute('disabled', 'disabled');
        fetch('/cart/add.json', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: idField.value, quantity: 1 })
        }).then(function (res) { return res.json(); }).then(function () {
          track('Suggested Added To Cart', { result: data.label, variant_id: idField.value }, slug);
          if (window.cart_popup && typeof window.cart_popup.updateCartPopup === 'function') {
            window.cart_popup.updateCartPopup(function () {
              Array.prototype.forEach.call(document.querySelectorAll('.cart-popup-wrapper'), function (el) { el.classList.add('open'); });
              document.documentElement.classList.add('cart-popup-wrapper-open');
            });
          } else if (document.querySelector('.nav-bag-li a')) { document.querySelector('.nav-bag-li a').click(); }
          if (btn) { var o = btn.textContent; btn.textContent = 'Added'; window.setTimeout(function () { btn.textContent = o; btn.removeAttribute('disabled'); }, 2000); }
        }).catch(function () { if (btn) btn.removeAttribute('disabled'); });
      });
    });

    /* waitlist */
    var form = root.querySelector('[data-boa-form]');
    var emailEl = root.querySelector('[data-boa-email]');
    var msgEl = root.querySelector('[data-boa-form-msg]');
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (emailEl && emailEl.value || '').trim();
      if (!emailValid(email)) { if (msgEl) msgEl.textContent = 'Please enter a valid email.'; return; }
      if (msgEl) msgEl.textContent = 'One moment...';
      var label = data.label;
      var idProps = { result: label, influencer_slug: slug };
      if (name) idProps['$first_name'] = name;
      identify(email, idProps);
      var kp = cfg.klaviyo || {};
      var done = function (ok) {
        if (msgEl) msgEl.textContent = ok ? (cfg.copy && cfg.copy.formSuccess ? cfg.copy.formSuccess : 'You are on the list.') : 'Something went wrong. Please try again.';
        if (ok) track('Waitlist Signed Up', { result: label }, slug);
      };
      if (!kp.listId) { done(true); return; }
      try {
        var body = new URLSearchParams();
        body.append('g', kp.listId); body.append('email', email); body.append('result', label);
        if (slug) body.append('influencer_slug', slug);
        body.append('$fields', 'result,influencer_slug');
        fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
          method: 'POST', headers: { 'content-type': 'application/x-www-form-urlencoded' }, body: body.toString()
        }).then(function (res) { return res.json(); }).then(function (j) { done(!!(j && (j.success || j.data))); }).catch(function () { done(true); });
      } catch (err) { done(true); }
    });

    /* share */
    var canvas = root.querySelector('[data-boa-canvas]');
    function wrap(ctx, text, x, y, maxW, lh) {
      var words = String(text).split(' '), line = '', lines = [];
      for (var i = 0; i < words.length; i++) { var test = line + words[i] + ' '; if (ctx.measureText(test).width > maxW && line) { lines.push(line.trim()); line = words[i] + ' '; } else line = test; }
      lines.push(line.trim());
      var start = y - ((lines.length - 1) * lh) / 2;
      lines.forEach(function (ln, idx) { ctx.fillText(ln, x, start + idx * lh); });
    }
    function buildCard() {
      if (!canvas || !canvas.getContext) return;
      var W = 1080, H = 1920; canvas.width = W; canvas.height = H;
      var ctx = canvas.getContext('2d');
      function draw() {
        ctx.fillStyle = '#FFFEF2'; ctx.fillRect(0, 0, W, H);
        var grad = ctx.createLinearGradient(0, 0, 0, H);
        if (r === 'zafran') { grad.addColorStop(0, 'rgba(224,78,57,0.16)'); grad.addColorStop(0.5, 'rgba(224,78,57,0.04)'); grad.addColorStop(1, 'rgba(242,241,230,0)'); }
        else { grad.addColorStop(0, 'rgba(78,54,41,0.14)'); grad.addColorStop(0.5, 'rgba(78,54,41,0.04)'); grad.addColorStop(1, 'rgba(242,241,230,0)'); }
        ctx.fillStyle = grad; ctx.fillRect(0, 0, W, H);
        ctx.textAlign = 'center';
        ctx.fillStyle = 'rgba(78,54,41,0.75)'; ctx.font = '600 30px "p22-underground-medium", Helvetica, Arial, sans-serif';
        ctx.fillText('O R M O N D E   J A Y N E', W / 2, 210);
        ctx.fillStyle = '#4E3629'; ctx.font = '400 98px "TradeGothicLTStd-Extended", Helvetica, Arial, sans-serif';
        wrap(ctx, data.title.toUpperCase(), W / 2, H / 2 - 60, 940, 108);
        ctx.fillStyle = 'rgba(78,54,41,0.85)'; ctx.font = 'italic 44px Georgia, serif';
        wrap(ctx, data.mood, W / 2, H / 2 + 140, 820, 58);
        ctx.fillStyle = '#E04E39'; ctx.font = '600 30px "p22-underground-medium", Helvetica, Arial, sans-serif';
        ctx.fillText(data.triplet.join('   ·   ').toUpperCase(), W / 2, H / 2 + 290);
        ctx.fillStyle = '#4E3629'; ctx.font = '400 56px "TradeGothicLTStd-Extended", Helvetica, Arial, sans-serif';
        ctx.fillText('ZAFRAN vs PATCHOULI', W / 2, H - 230);
        ctx.fillStyle = '#E04E39'; ctx.font = '600 28px "p22-underground-medium", Helvetica, Arial, sans-serif';
        ctx.fillText('#ZafranVsPatchouli', W / 2, H - 170);
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(draw).catch(draw); else draw();
    }
    buildCard();

    var dl = root.querySelector('[data-boa-share-download]');
    if (dl) dl.addEventListener('click', function () {
      var name = 'zafran-vs-patchouli-' + r + (slug ? '-' + slug : '') + '.png';
      track('Share Card Downloaded', { result: data.label }, slug);
      try {
        canvas.toBlob(function (blob) {
          if (!blob) return; var url = URL.createObjectURL(blob); var a = document.createElement('a');
          a.href = url; a.download = name; document.body.appendChild(a); a.click(); document.body.removeChild(a);
          window.setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
        }, 'image/png');
      } catch (e) { try { var a2 = document.createElement('a'); a2.href = canvas.toDataURL('image/png'); a2.download = name; a2.click(); } catch (e2) {} }
    });
    var sl = root.querySelector('[data-boa-share-link]');
    if (sl) sl.addEventListener('click', function () {
      var url = window.location.href;
      var shareData = { title: 'Zafran vs Patchouli', text: data.title + ' ' + (data.mood || '') + ' #ZafranVsPatchouli', url: url };
      if (navigator.share) { navigator.share(shareData).catch(function () {}); }
      else if (navigator.clipboard) { navigator.clipboard.writeText(url).then(function () { if (msgEl) msgEl.textContent = 'Link copied.'; }).catch(function () {}); }
    });
  }

  ready(function () {
    Array.prototype.forEach.call(document.querySelectorAll('.boa-quiz'), initQuiz);
    Array.prototype.forEach.call(document.querySelectorAll('.boa-result'), initResult);
  });
})();
